import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';

import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';

import SubjectListItem from './SubjectListItem';

const SubjectsList = (props) => {
  const {
    subjects: pSubjects,
    loading,
    isSubjectOpen,
    isSubjectSelected,
    showSelectedMark,
    onSelectSubject,
    disableDragAndDrop,
    level,
    openMenuSubjectId,
    onOpenMenu,
    onCloseMenu,
    onAddSubject,
    onEditSubject,
    onRemoveSubject,
    onToggleSubject,
  } = props;

  const subjects = loading ? Array.from(new Array(4)) : pSubjects;

  return (
    <List style={{ marginLeft: 8 * Math.min(level, 2) }}>
      {subjects.map((subject, index) => {
        const { subjects: subSubjects = [] } = subject || {};
        const open = isSubjectOpen(subject);

        return (
          <SubjectListItem
            loading={loading}
            index={index}
            disabled={disableDragAndDrop}
            collection={subject?.parentSubject || 'root'}
            key={subject?._id || index}
            showSelectedMark={showSelectedMark}
            subject={subject}
            open={open}
            selected={isSubjectSelected(subject)}
            onClick={onSelectSubject}
            menuOpen={subject?._id === openMenuSubjectId}
            onOpenMenu={onOpenMenu}
            onCloseMenu={onCloseMenu}
            onAddSubject={level < 2 ? onAddSubject : undefined}
            onEditSubject={onEditSubject}
            onRemoveSubject={onRemoveSubject}
            onToggleSubject={onToggleSubject}
          >
            {subSubjects.length > 0 && (
              <Collapse in={open} timeout="auto" unmountOnExit>
                <SubjectsList
                  loading={loading}
                  disableDragAndDrop={disableDragAndDrop}
                  subjects={subSubjects}
                  showSelectedMark={showSelectedMark}
                  isSubjectOpen={isSubjectOpen}
                  isSubjectSelected={isSubjectSelected}
                  onSelectSubject={onSelectSubject}
                  level={level + 1}
                  openMenuSubjectId={openMenuSubjectId}
                  onOpenMenu={onOpenMenu}
                  onCloseMenu={onCloseMenu}
                  onAddSubject={onAddSubject}
                  onEditSubject={onEditSubject}
                  onRemoveSubject={onRemoveSubject}
                  onToggleSubject={onToggleSubject}
                />
              </Collapse>
            )}
          </SubjectListItem>
        );
      })}
    </List>
  );
};

SubjectsList.propTypes = {
  subjects: PropTypes.array,
  loading: PropTypes.bool,
  disableDragAndDrop: PropTypes.bool,

  showSelectedMark: PropTypes.bool,
  isSubjectOpen: PropTypes.func.isRequired,
  isSubjectSelected: PropTypes.func.isRequired,
  onSelectSubject: PropTypes.func.isRequired,

  openMenuSubjectId: PropTypes.string,
  onOpenMenu: PropTypes.func,
  onCloseMenu: PropTypes.func,

  level: PropTypes.number,

  onAddSubject: PropTypes.func,
  onEditSubject: PropTypes.func,
  onRemoveSubject: PropTypes.func,
  onToggleSubject: PropTypes.func,
};

SubjectsList.defaultProps = {
  subjects: [],
  loading: false,
  disableDragAndDrop: false,
  level: 0,
  showSelectedMark: false,
  openMenuSubjectId: undefined,
  onOpenMenu() {},
  onCloseMenu() {},

  onAddSubject: undefined,
  onEditSubject: undefined,
  onRemoveSubject: undefined,
  onToggleSubject: undefined,
};

export default SortableContainer(SubjectsList);
